//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableSkelenton from '@/components/Skeletons/TableSkeleton'
import Solicitudes from '@/api/promotores/usuarios/solicitudes.api'
export default {
  components: {
    TableSkelenton
  },
  data() {
    return {
      per_page_options: [10, 20, 30, 40, 50, 100],
      columns: [
        { name: "id", label: "Id", field: "id", style: "width: 10px", sortable: true },
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre",
          align: "left",
          classes: "bg-grey-2 ellipsis",
          style: "width: 350px",
          headerClasses: "bg-primary text-white",
        },
        {
          name: "importe",
          label: "Monto solicitado",
          field: "importe_solicitado",
          sortable: true,
          format: this.currency,
        },
        {
          name: "autorizado",
          label: "Monto autorizado",
          field: "ejercido.monto_autorizado_comite",
          sortable: true,
          format: this.currency,
        },
        { name: "plazo", label: "Plazo", field: "plazo", sortable: true, format: this.formatPlazo },
        { name: "email", label: "Correo electrónico", field: "email" },
        { name: "telefono", label: "Télefono", field: "telefono" },
        { name: "descripcion", label: "Descripción", field: "en_tarea_hasta", sortable: true },
        {
          name: "creacion",
          label: "Creación",
          field: "created_at",
          sortable: true,
        },
        { name: "estado", label: "Estado", format: this.formatArea },
      ],
      solicitudes: [],
      loading: false,
    }
  },

  mounted() {
    this.loadSolicitudes()
  },

  methods: {
    async loadSolicitudes() {
      try {
        this.loading = true
        this.solicitudes = await Solicitudes.all(this.$route.params.promotor)
      } finally {
        this.loading = false
      }
    },
    rowClick(e, solicitud) {
      window.open(process.env.VUE_APP_SERVICIOS_WEB + "/operacion/detalles/" + solicitud.id, "_blank")
    },
    formatArea(area, solicitud) {
      const areas = ["ejercido", "comite", "entrevistas", "citas", "opinion", "callback"]

      for (let area of areas) {
        if (solicitud[`procede_${area}`] === 1) {
          return `Procede ${area}`
        }

        if (solicitud[`procede_${area}`] === 0) {
          return `No procede ${area}`
        }

        if (solicitud[`procede_${area}`] === null && solicitud[`created_${area}`] !== null) {
          return `Pendiente ${area}`
        }

        if (solicitud[`procede_${area}`] === 2) {
          return `Prospecto ${area}`
        }
      }

      return "Pendiente callback"
    },
    formatPlazo(plazo) {
      return this.pluralize(plazo, ["año", "años"])
    },
  },
}
